jQuery( function(){

    $( document ).ajaxSuccess( function ( event, xhr, settings ) {
        let elements = document.querySelectorAll( '.blog-list__item, .success-stories-list__item' );

        for ( let elm of elements ) {
            observer.observe( elm );
        }
    } );

    function onEntry( entry ) {
        entry.forEach( change => {
            if ( change.isIntersecting ) {
                change.target.classList.add( 'element-show' );
            }
        } );
    }

    let options = {
        threshold: [0.1]
    };
    let observer = new IntersectionObserver( onEntry, options );
    let elements = document.querySelectorAll( '.blog-list__item, .success-stories-list__item' );

    for ( let elm of elements ) {
        observer.observe( elm );
    }

    if($('body').hasClass('without-animation')) {
        for (let elem of elements) {
            elem.classList.add('element-show');
        }
    }

    $(document).on('accessibilityPreEvent', function (e) {
        if ( e.originalEvent.detail['without-animation'] ) {
            for (let elem of elements) {
                elem.classList.add('element-show');
            }
        }
    });

});

$(document).ready(function () {

    let listCategories = () => {
        let arr = [];
        $('.dropdown_choose-categories label').each( (elem1) => {
           if ($('.dropdown_choose-categories label')[elem1].children[0].checked) {
               arr.push($('.dropdown_choose-categories label')[elem1].children[1].textContent);
           }
        });

        $('.page-banner-list p').empty();
        $('.page-banner-list p').append(`Latest posts for: `)
        for (let i = 0; i < arr.length; i++) {
            $('.page-banner-list p').append(`<span>${arr[i]}</span> `);
            if (arr[i] === 'All') break;
        }
    };

    listCategories();


    var SortBlog = {

        activeClassTag: 'is-active',
        resultID: '#js-result',
        categoryID: undefined,
        tagsArrayID: [],
        taxQuery: [],

        init: function () {
            console.log("Action: init");

            var thisClass = this;
            var slidesCounter = getSlidesCounter();
            thisClass.getTaxQuery();

            // Search by tag
            thisClass.findByPostCategoryAndActivateButtonTags();

            $('.dropdown_choose-categories input').on('change', function(e){
                const categoriesInputs = $('.dropdown_choose-categories input').not('#category-input-all');
                const categoriesInputsChecked = categoriesInputs.filter((_, el) => el.checked);
                const el = e.target.closest('#category-input-all');
                if (!el) {
                    $('#category-input-all').prop('checked', categoriesInputs.length === categoriesInputsChecked.length);
                } else {
                    categoriesInputs.prop('checked', el.checked);
                }
                thisClass.getActiveCategory();
                thisClass.ajax();
                listCategories();
            });
            $('.clear-all-categories').click(() => {
                $('.dropdown_choose-categories input').prop('checked', false);
                thisClass.getActiveCategory();
                thisClass.ajax();
                listCategories();
            });

            initSliderWithValues(slidesCounter);

            thisClass.resetActiveClassWithParametrs();
        },

        getQueryVariable: function (variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return false;
        },

        removeActiveClassFromSlickSlider: function () {
            var thisClass = this;
            $('#js-categories li').each(function () {
                $(this).find('a').removeClass(thisClass.activeClassTag);
            });

            $(this).addClass(thisClass.activeClassTag);
        },

        getActiveCategory: function (e) {

            let checked_inputs= [];
            let get_string = '';
            const isAllSelected = $('.dropdown_choose-categories input#category-input-all').is(':checked');
            if (!isAllSelected) {
                if( $('.dropdown_choose-categories input:checked').length == 1 ) {
                    checked_inputs.push( $('.dropdown_choose-categories input:checked').val() );
                    get_string += 'by_category=' + $('.dropdown_choose-categories input:checked').val();
                } else {
                    $('.dropdown_choose-categories input:checked').each(function(){
                        checked_inputs.push(jQuery(this).val());
                        if ( get_string != '' ) {
                            get_string += '&';
                        }

                        get_string += 'by_category[]=' + jQuery( this ).val();
                    })
                }

            }
            if( get_string != '' ){
                get_string = '?' + get_string;
            }

            const currentUrl = window.location.href;
            const urlWithoutParams = currentUrl.split('?')[0];
            const newUrl = urlWithoutParams + get_string;
            const urlWithoutPage = newUrl.replace(/\/page\/\d+\//, '/');
            window.history.pushState(null, null, urlWithoutPage);

            var thisClass = this;
            thisClass.categoryID = JSON.stringify( checked_inputs );

        },

        getActiveTags: function () {

            var thisClass = this;

            thisClass.tagsArrayID = [];

            $('#js-tags li.is-active').each(function () {

                thisClass.tagsArrayID.push($(this).find('a').data('id'));

            });

        },

        getTaxQuery: function () {

            var thisClass = this;

            thisClass.taxQuery = this.getParameter('project_type');
        },

        ajax: function () {
            console.log("Action: category\\tag ajax");

            var thisClass = this;
            var select = {
                action: 'ajax_get_posts_by_category_and_tags',
                by_category: thisClass.categoryID,
            };
            pagination.current_page = 1;

            $.ajax({
                url: options.ajax_url, // declarate in wordpress
                type: 'POST',
                data: select,
                dataType: 'json',
                success: function (data) {

                    var screenWidth = getScreenWith();

                    $(thisClass.resultID).html(data.html);
                    pagination.param_posts = data.param_posts;

                    thisClass.findByPostCategoryAndActivateButtonTags();

                    $('#js-result').css({'opacity': 1});

                    deleteCallContextMenu();
                    truncatePostContent(
                        document.querySelectorAll('.blog-list__item-title'),
                        document.querySelectorAll('.blog-list__item-text'),
                        3,
                        4
                    );
                    if ((screenWidth > 767 && screenWidth < 1024) || (screenWidth < 767)) {
                        truncatePostContent(
                            document.querySelectorAll('.success-stories-list__item-title'),
                            document.querySelectorAll('.success-stories-list__item-text'),
                            3,
                            3
                        );
                    } else {
                        truncatePostContent(
                            document.querySelectorAll('.success-stories-list__item-title'),
                            document.querySelectorAll('.success-stories-list__item-text'),
                            3,
                            4
                        );
                    }
                    showCardPreview();
                    addScrollByClickOnPostLinks();
                    let localData = localStorage.getItem("subscribe"),
                        section = ".section-subscription";
                    if (localData) {
                        $(section).find(".subscription-form").remove();
                        $(section).find(".subscription-thanks").show();
                    }
                },
                beforeSend: function () {
                    $('#js-result').css({'opacity': 0.3});
                },
                complete: function () {
                    ComeBack.createActions();
                }
            });

        },

        ajaxLoadMore: function (bottomOffset) {
            if( pagination.param_posts ) {
                var thisClass = this,
                    select = {
                        action: 'loadmore',
                        by_category: thisClass.categoryID,
                        custom_post_type: $(thisClass.resultID).data('post-type'),
                        query: pagination.param_posts,
                        page: parseInt(pagination.current_page),
                        is_subscribed: !!localStorage.getItem("subscribe"),
                    };

                if (pagination.current_page >= pagination.max_pages) {
                    return false;
                } // if there are no more pages

                if (this.isScrolledIntoView('footer') || this.isScrolledIntoView('section.contact-form-section')) {
                    return false;
                } // Don't get posts if is scroll on footer or form
                console.log("Action: before ajax Load More");
                if ($(document).scrollTop() > ($(document).height() - bottomOffset) && !$('body').hasClass('loading')) {

                    console.log("Action: ajax Load More");

                    $.ajax({
                        url: options.ajax_url, // declarate in wordpress
                        data: select,
                        type: 'POST',
                        beforeSend: function () {
                            $('body').addClass('loading');
                        },
                        complete: function () {
                            $('body').removeClass('loading');

                            // Action come back
                            ComeBack.createActions();
                        },
                        success: function (data) {

                            $(thisClass.resultID).append(data); // paste html
                            pagination.current_page++; // increase the number page

                            truncatePostContent(
                                document.querySelectorAll('.success-stories-list__item-title'),
                                document.querySelectorAll('.success-stories-list__item-text'),
                                2,
                                3
                            );

                            truncatePostContent(
                                document.querySelectorAll('.blog-list__item-title'),
                                document.querySelectorAll('.blog-list__item-text'),
                                3,
                                4
                            );

                            // Search by tag
                            thisClass.findByPostCategoryAndActivateButtonTags();
                            addScrollByClickOnPostLinks();
                            showCardPreview();

                            // Block subscription
                            let localData = localStorage.getItem("subscribe"),
                                section = ".section-subscription";
                            if (localData) {
                                $(section).find(".subscription-form").remove();
                                $(section).find(".subscription-thanks").show();
                            }
                        }
                    });
                }
            }
        },

        isScrolledIntoView: function (elem) {
            const docViewTop = $(window).scrollTop();
            const docViewBottom = docViewTop + $(window).height();

            const elemTop = $(elem).offset().top;
            const elemBottom = elemTop + $(elem).height();

            return elemBottom <= docViewBottom && elemTop >= docViewTop;
        },

        findByPostCategoryAndActivateButtonTags: function () {

            var thisClass = this;

            $(thisClass.resultID).find('a.js-cat').on('click', function (e) {
                e.preventDefault();

                var categoryValue = $(this).text().trim();
                thisClass.categoryID = $(this).data('id');

                thisClass.ajax();

                $('#js-categories li ').each(function () {

                    $(this).removeClass(thisClass.activeClassTag);

                    if ($(this).data('id') === thisClass.tagsArrayID) {

                        $(this).addClass(thisClass.activeClassTag);

                    }

                });

                thisClass.switchSlide(categoryValue);

                // Activate tab current category
                $('#js-categories a').each(function (index, element) {

                    $(this).removeClass(thisClass.activeClassTag);

                    if ($(this).data('id') === thisClass.categoryID) {

                        $(this).addClass(thisClass.activeClassTag);

                    }
                });
            })

        },

        switchSlide: function (categoryValue) {
            $('.tabs-list-link').each(function (index, element) {
                if ($(element).text().trim() === categoryValue) {
                    console.log('Action: switch slide', index);
                    // $(".tabs-list.slider").slick('slickSetOption', 'initialSlide', 1);
                    $(".tabs-list.slider").slick('slickGoTo', +index, false);
                }
            })
        },

        findByPostTagAndActivateButtonTags: function (e) {

            var thisClass = this;

            $(thisClass.resultID).find('a.js-tag').on('click', function (e) {
                e.preventDefault();

                thisClass.tagsArrayID = $(this).data('id');

                thisClass.ajax();

                // Activate button only for pressed tags
                $('#js-tags li').each(function () {

                    $(this).removeClass(thisClass.activeClassTag);

                    if ($(this).data('id') === thisClass.tagsArrayID) {

                        $(this).addClass(thisClass.activeClassTag);

                    }

                });

                // Activate tab category all
                $('#js-categories a').each(function () {

                    $(this).removeClass(thisClass.activeClassTag);

                })

            });

        },

        resetActiveClassWithParametrs: function () {

            var thisClass = this,
                by_cat = thisClass.getQueryVariable('by_category'),
                by_tag = thisClass.getQueryVariable('by_tag');

            if (by_cat.length) {

                $('#js-categories a').each(function () {

                    $(this).removeClass(thisClass.activeClassTag);

                    if ($(this).data('id') === parseInt(by_cat)) {

                        $(this).addClass(thisClass.activeClassTag);

                    }

                });

            } else if (by_tag.length) {

                $('#js-tags li').each(function () {

                    if ($(this).find('a').data('id') === parseInt(by_tag)) {

                        $(this).addClass(thisClass.activeClassTag);

                        $('.js-show-more').find('button').click();

                    }

                });

            }
        },

        getParameter: function (paramName) {
            let decodeSearch = decodeURI(window.location.search),
                searchString = decodeSearch.substring(1),
                i, val, params = searchString.split("&");

            for (i = 0; i < params.length; i++) {
                val = params[i].split("=");
                if (val[0] == paramName) {
                    return val[1];
                }
            }
            return null;
        }
    };

    //SortBlog.getActiveCategory();
    /*
    * Come back to the active category and the scroll position
    */
    var ComeBack = {
        postItems: '',
        categoryItem: '',
        storeKeyPostId : 'postID',
        storeKeyCatId : 'catID',

        init: function () {
            this.createActions();
            this._returnToCat();
        },

        createActions:function () {
            this.postItems = document.querySelectorAll('#js-result .post-item');
            this.categoryItem = document.querySelector('#js-categories .slider__item .is-active');
            this._createOnCLick();
        },

        _createOnCLick: function () {
            var $this = this;
            this.postItems.forEach(function (el) {
                el.onclick = function (event) {
                    // event.preventDefault();
                    $this._saveData({
                        postID: this.dataset.postId,
                        catID: $this.categoryItem.dataset.id
                    });
                };
            });
        },

        _saveData: function (data) {
            localStorage.setItem(this.storeKeyPostId, data.postID)
            localStorage.setItem(this.storeKeyCatId, data.catID)
        },

        _returnToCat: function () {
            var key = localStorage.getItem(this.storeKeyCatId);
            if(key && key !== 'undefined') {
                // get slick index by category ID
                var index = $('#js-categories .slider__item a[data-id="' + key + '"]');
                if (!index) {
                    return false;
                }
                // go to slick index
                setTimeout(function () {
                    SortBlog.switchSlide(index.text().trim());
                    SortBlog.categoryID = +key
                    $('#js-categories a').each(function (index, element) {

                        $(this).removeClass(SortBlog.activeClassTag);

                        if ($(this).data('id') === SortBlog.categoryID) {

                            $(this).addClass(SortBlog.activeClassTag);

                        }
                    });
                    SortBlog.ajax();

                }, 500);
                this._removeData();
            } else {
                console.log('empty');
            }
        },

        _removeData: function () {
            localStorage.removeItem(this.storeKeyCatId);
            localStorage.removeItem(this.storeKeyPostId);
        },

        parents: function (element, selector) {
            element = element.parentNode;

            // Find class
            if (selector.includes('.')) {
                if (element.classList.contains(selector.replace('.', ''))) {
                    return element;
                }
            }

            return this.parents(element, selector);
        }
    };

    jQuery(function () {
        SortBlog.init();
        if ( pagination.business_domain != undefined ) {
            SortBlog.categoryID = pagination.business_domain;
        }
        // setTimeout(function () {
        //     ComeBack.init();
        // }, 300);
    });

    function getScreenWith() {
        return window.innerWidth;
    }

    function getSlidesCounter() {
        var screenWidth = getScreenWith();
        var slidesCounter = $('.tabs-list').data('count');

        if (screenWidth > 1300 && slidesCounter > 7) {
            slidesCounter = 7;
        }
        if (screenWidth > 1023 && screenWidth < 1300) {
            if (slidesCounter > 4) {
                slidesCounter = 4;
            }
        } else if (screenWidth > 767 && screenWidth < 1024) {
            if (slidesCounter > 3) {
                slidesCounter = 3;
            }
            var successPostTitles = document.querySelectorAll('.success-stories-list__item-title');
            var successPostTextItems = document.querySelectorAll('.success-stories-list__item-text');
            truncatePostContent(successPostTitles, successPostTextItems, 2, 3);
        } else if (screenWidth > 530 && screenWidth < 768) {
            if (slidesCounter > 2) {
                slidesCounter = 2;
            }
        }
        return slidesCounter;
    }

    function initSliderWithValues(slidesCounter) {
        $(".tabs-list.slider").slick('slickSetOption', 'responsive', [
            {
                breakpoint: 2550,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    arrows: true
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: slidesCounter,
                    slidesToScroll: 4,
                    arrows: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slidesCounter,
                    slidesToScroll: 3,
                    arrows: true,
                }
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: slidesCounter,
                    slidesToScroll: 2,
                    arrows: true
                }
            },
            {
                breakpoint: 530,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: true
                }
            }], true)
    }

    $(window).on("resize", function () {
        var slidesCounter = getSlidesCounter();
        if (!$(".tabs-list.slider").hasClass('slick-initialized')) {
            $(".tabs-list.slider").slick({
                slidesToShow: slidesCounter,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<div class="tabs-list__arrow-wrapper tabs-list__arrow-wrapper--prev">' +
                    '<div class="tabs-list__arrow">' +
                    '<img class="tabs-list__arrow-img tabs-list__arrow--next" src="/wp-content/themes/nix_united/assets/img/arrow/slider-arrow-right.svg" alt="">' +
                    '</div>' +
                    '</div>',
                nextArrow: '<div class="tabs-list__arrow-wrapper tabs-list__arrow-wrapper--next">' +
                    '<div class="tabs-list__arrow">' +
                    '<img class="tabs-list__arrow-img tabs-list__arrow--prev" src="/wp-content/themes/nix_united/assets/img/arrow/slider-arrow-right.svg" alt="">' +
                    '</div>' +
                    '</div>',
                infinite: false,
            })
        }
        initSliderWithValues(slidesCounter);
    }).trigger('resize');

    //for page blog/////////////////////////////////////////////////////////////////////////////////////////////////////////////
    let allCheckboxes = document.querySelectorAll('.dropdown_choose-categories label');

    $('.open-dropdown').click(() => {
       if($('.dropdown_choose-categories').hasClass('hidden')) {
           $('.dropdown_choose-categories').removeClass('hidden');
           $('.open-dropdown img').css('transform', 'rotate(0deg)');
       } else {
           $('.dropdown_choose-categories').addClass('hidden');
           $('.open-dropdown img').css('transform', 'rotate(180deg)');
       }
    });
    // $('.dropdown_choose-categories label').click((e) => {
    //     let fakeCheckbox = e.target.parentElement.children[0];
    //     if(fakeCheckbox.classList.contains('checked')) {
    //         fakeCheckbox.classList.remove('checked');
    //     } else {
    //         fakeCheckbox.classList.add('checked');
    //     }
    //     // console.log(e.target.textContent.trim());
    //     // $('.page-banner__text-wrapper p')[0].textContent = `${$('.page-banner__text-wrapper p')[0].textContent} | ${e.target.textContent.trim()}`;
    //     // $('.page-banner__text-wrapper p').textContent = e.target.textContent;
    // });
    // $('.dropdown_choose-categories label span').click((e) => {
    //     let fakeCheckbox1 = e.target;
    //     if(fakeCheckbox1.classList.contains('checked')) {
    //         fakeCheckbox1.classList.remove('checked');
    //     } else {
    //         fakeCheckbox1.classList.add('checked');
    //     }
    // });

    const blogMedia = document.querySelectorAll('.blog-list__item-media-wrap');

    blogMedia.forEach((blogMediaItem)=>{
        blogMediaItem.addEventListener('click', ()=>{

            const linkBlogArticle = blogMediaItem.closest('.blog-list__item').querySelector('a').getAttribute('href');

            if (linkBlogArticle) window.open(linkBlogArticle, '_self');
        })
    })

});

var blogPostTitles = document.querySelectorAll('.blog-list__item-title');
var blogPostTextItems = document.querySelectorAll('.blog-list__item-text');
var successPostTextItems = document.querySelectorAll('.success-stories-list__item-text');
var successStoriesListItems = document.querySelectorAll('.success-stories-list__item');
var successStoriesCardsContentInner = document.querySelectorAll('.success-stories-list__item-content-inner');

deleteCallContextMenu();
truncatePostContent(blogPostTitles, blogPostTextItems, 3, 4);



showCardPreview();

function addScrollByClickOnPostLinks(){
    var postLinks = document.querySelectorAll('.posts-list__btn');
    var anchorId = '.tabs-list';
    if( $(anchorId).length ) {
        var top = $(anchorId).offset().top - 110;

        for (var i = 0; i < postLinks.length; i++) {
            $(postLinks[i]).on('click', function(event){
                event.preventDefault();
                $('body,html').animate({scrollTop: top}, 500);
            })
        }
    }

}

function addScrollByClickOnTabs(){
    var tabs = document.querySelectorAll('.tabs-list-link');
    if (tabs.length) {
        var anchorId = '.tabs-list';
        var screenWidth = window.innerWidth;
        var top = 0;
        screenWidth <= 768 ? top = +$(anchorId).offset().top - 30 : top = +$(anchorId).offset().top - 110;

        for (var i = 0; i < tabs.length; i++) {
            $(tabs[i]).on('click', function(event){
                event.preventDefault();
                $('body,html').animate({scrollTop: top}, 750);
            })
        }
    }
}


addScrollByClickOnTabs();
addScrollByClickOnPostLinks();
